<template>
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.8667 28.1933H11.2583V16.7316H14.8667V28.1933ZM13.06 15.1433C12.6507 15.141 12.2512 15.0175 11.9121 14.7884C11.5729 14.5593 11.3092 14.2348 11.1542 13.856C10.9992 13.4771 10.96 13.0609 11.0414 12.6598C11.1227 12.2586 11.3211 11.8906 11.6115 11.6021C11.9018 11.3136 12.2711 11.1176 12.6728 11.0388C13.0745 10.96 13.4904 11.0019 13.8683 11.1593C14.2461 11.3167 14.5689 11.5825 14.7958 11.9231C15.0227 12.2638 15.1437 12.664 15.1433 13.0733C15.1472 13.3473 15.0958 13.6193 14.9923 13.8731C14.8888 14.1269 14.7353 14.3572 14.5409 14.5504C14.3465 14.7435 14.1152 14.8956 13.8608 14.9975C13.6063 15.0993 13.334 15.1489 13.06 15.1433ZM28.1667 28.2033H24.56V21.9416C24.56 20.095 23.775 19.525 22.7617 19.525C21.6917 19.525 20.6417 20.3316 20.6417 21.9883V28.2033H17.0333V16.74H20.5033V18.3283H20.55C20.8983 17.6233 22.1183 16.4183 23.98 16.4183C25.9933 16.4183 28.1683 17.6133 28.1683 21.1133L28.1667 28.2033Z"
      fill="currentColor"
    />
    <rect
      x="0.5"
      y="0.5"
      width="39"
      height="39"
      rx="19.5"
      stroke="currentColor"
    />
  </svg>
</template>
